import { type ReactElement } from 'react'
import { useNavigate, createFileRoute } from '@tanstack/react-router'
import { useToastError } from '@hooks'
import { useAddQuestion, useTranslation } from '@front/model'
import { ButtonSave, Page, QuestionForm, useQuestionForm, type QuestionFormOutput } from '@components'

function QuestionAddPage(): ReactElement {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { add, isAdding, error } = useAddQuestion()
  const form = useQuestionForm()
  useToastError(error)

  const handleSubmit = async (values: QuestionFormOutput): Promise<void> => {
    const result = await add({
      question: {
        text: values.text,
        choiceType: values.choiceType,
        startDate: values.startDate,
        endDate: values.endDate,
        askToShareWithManager: values.askToShareWithManager,
        confirmManager: values.confirmManager,
        category: values.category,
        recurs: values.recurs,
        skipBehavior: values.skipBehavior,
        choices: values.choices,
        rules: values.rules,
        followUps: values.followUps,
      },
    })
    navigate({ to: `/questions/${result.question.questionId}` })
  }

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Page>
        <Page.Heading back title={t('Add Startup Question')}>
          <ButtonSave loading={isAdding} type='submit' disabled={!form.isDirty() || !form.isValid()}>
            {t('Save')}
          </ButtonSave>
        </Page.Heading>
        <Page.Content scrollArea>
          <QuestionForm form={form} />
        </Page.Content>
      </Page>
    </form>
  )
}

export const Route = createFileRoute('/questions_/add/')({
  component: QuestionAddPage,
})
